export default __webpack_public_path__ + "static/media/downloadexcel.bca7557a.svg";